import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export const ChatHeader: React.FC = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>StudyBuddy</title>
        <meta name="description" content="StudyBuddy is a modern LLM chat app featuring multiple advanced AI models, including a powerful tutor. Chat, explore, and get instant answers or assistance on any topic." />
        <meta name="keywords" content="StudyBuddy, Cognora AI, LLM chat, AI chatbot, language model, GPT, Claude, Gemini, AI assistant, chat app, multi-model chat, AI conversation, AI tutor, AI helper, artificial intelligence, chat with AI, chatbot, generative AI, AI models, chat, Cognora, studybuddy, study buddy, ai chat, ai assistant, ai models, chatgpt, openai, anthropic, google gemini, ai platform, ai tools" />
        <meta property="og:title" content="StudyBuddy - Multi-Model AI Chat App" />
        <meta property="og:description" content="Chat with advanced AI models, including tutors and assistants. Switch between LLMs and get instant help, answers, and insights." />
        <link rel="canonical" href="https://studdybuddy.ca/" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://studdybuddy.ca" />
        <meta name="author" content="Cognora" />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "SoftwareApplication",
            "name": "StudyBuddy",
            "applicationCategory": "ChatApplication",
            "creator": {
              "@type": "Organization",
              "name": "Cognora",
              "url": "https://cognora.ca"
            },
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "description": "A multi-model AI chat platform by Cognora. Chat with various large language models, including tutors and assistants, for instant answers and conversation.",
            "featureList": [
              "Chat with multiple advanced AI models",
              "Switch between LLMs (GPT, Claude, Gemini, etc.)",
              "AI-powered tutoring and general conversation",
              "Image and PDF analysis",
              "Real-time AI responses",
              "Personal and professional assistant features"
            ]
          })}
        </script>
      </Helmet>
    </HelmetProvider>
  );
};